<template>
  <div>
    <portal to="toolbar-title"> Ανοιχτές Εκκρεμότητες (Υπόλοιπο: {{ totalDept - totalDeptStandBy | fixed }}‎€ | Αναμονή:
      {{ totalDeptStandBy |fixed }}‎€ )
    </portal>
    <portal to="toolbar-actions">
    </portal>
    <active-filters module-name="OpenDeptsHandler"/>
    <v-row>
      <v-toolbar flat color="transparent">
        <v-toolbar-title>
          Προβολή Οικονομικών Εκκρεμοτήτων
        </v-toolbar-title>
        <v-spacer/>
        <v-btn class="mr-3" outlined large color="primary" @click="exportToExcel('Οικονομικές Εκκρεμότητες')">
          <v-icon> mdi-file-excel</v-icon>
          ΛΗΨΗ EXCEL
        </v-btn>
        <v-btn v-if="userDetails.Allows.AllowPayments" color="success" to="/financial/dept/payments" large> ΠΛΗΡΩΜΗ
        </v-btn>
      </v-toolbar>
      <v-col md="12" lg="9" sm="12">
        <v-card>
          <v-card-text>
            <v-data-table id="table" :headers="headers" :items="data" :group-by="['PartnerBrandName']"
                          disable-pagination
                          hide-default-footer fixed-header height="70vh"
                          no-data-text="Δεν υπάρχουν οικονομικές εκκρεμότητες"
            >
              <template v-slot:group.header="{items,group}">
                <td colspan="5" class="text-start">
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-title class="text--black">
                        {{ group }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text> Υπόλοιπο</v-list-item-action-text>
                      <span
                          style="font-size: 1.4em">{{ items.map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) - items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed }}‎€ </span>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-list-item-action-text> Σε Αναμονή</v-list-item-action-text>
                      <span style="font-size: 1.4em">{{
                          items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                        }}‎€ </span>
                    </v-list-item-action>
                  </v-list-item>
                </td>
              </template>
              <template v-slot:item.Description="{item}">
              {{ item.Description }}
                <br/>
                <span style="color:green;" v-if="item.PendingAmount"> Αναμονή έκγρισης πληρωμής: {{item.PendingAmount}} €</span>
              </template>
              <template v-slot:item.NumberPar="{item}">
                <div v-if="item.NumberPar">{{ item.NumberPar }}</div>
                <div v-else>
                  <v-chip> Σε αναμονή</v-chip>
                </div>
              </template>
              <template v-slot:item.Balance="{item}">
                <div class="text-center faded font-weight-medium pa-2"
                     style="border-radius: 15px;">
                  {{ item.Balance | fixed }}‎€
                </div>
              </template>
              <template v-slot:item.DateInvoice="{item}">
                {{ item.DateInvoice | fullDate }}
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" lg="3" sm="12">
        <filters module-name="OpenDeptsHandler"/>
      </v-col>

    </v-row>


  </div>

</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex";
import store from "../../../store";
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import DeptItem from "../components/DeptItem";
import Filters from "../../../wl-datagrid-handler/Filters";
import ActiveFilters from "../../../wl-datagrid-handler/ActiveFilters";

export default {
  name: "DeptsDesktop",

  data: () => ({
    headers: [

      {
        text: 'Hμ/νια ',
        value: 'DateInvoice',
        filterable: true,
        width: "100"
      },
      {
        text: '# Παρ.',
        value: 'NumberPar',
        filterable: true,
        width: "50"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
      {
        text: 'Κτήριο',
        value: 'FullBranch',
        filterable: true,
        width: "200"
      },

      {
        text: 'Πελάτης',
        value: 'PartnerBrandName',
      },

      {
        text: 'Ποσό',
        value: 'Balance',
        filterable: true,
        width: "100"
      },
    ]
  }),
  components: {ActiveFilters, Filters, DeptItem},
  computed: {
    ...mapGetters('OpenDeptsHandler', [
      "data"
    ]),
    ...mapGetters([
      "openDepts",
      "userDetails",
      "totalDept",
      "totalDeptStandBy"
    ])
  },
  methods: {
    ...mapActions([
      "getOpenDepts",
      "getPartnerDetails",
      "exportToExcel"
    ]),
    ...mapMutations('OpenDeptsHandler', [
      "setData",
      "createFilters",
    ]),
    ...mapMutations([
      "showLoading",
      "setLoadingMessage",
      "hideLoading",
    ])
  },
  beforeCreate() {
    store.registerModule('OpenDeptsHandler', dataGridHandler);
  },
  created() {
    this.showLoading();
    this.setLoadingMessage("Ψάγνουμε για οφειλές");
    this.getPartnerDetails().then(
        () => this.getOpenDepts({}).then(openDepts => {
          this.setData(openDepts);
          this.createFilters([
            {
              unique: true,
              key: 'StatusName',
              name: 'Κατάσταση'
            },
            {
              key: 'PartnerBrandName',
              name: 'Έχει χρεωθεί σε'
            },

            {
              key: 'NumberPar',
              name: 'Παραστατικό'
            },

          ]);
          this.hideLoading();
        })
    )
  },

  beforeDestroy() {
    this.$store.unregisterModule('OpenDeptsHandler');
  },
}
</script>

<style scoped>

</style>
